import { ChatParticipant } from '@tribeplatform/gql-client/types'

import { useQuery, useQueryClient } from '../../lib/index.js'
import { getCachedChatParticipantsKey } from '../../utils/keys/messaging.key.js'

interface Args {
  chatId: string
}

export const useCachedParticipants = ({ chatId }: Args) => {
  const queryClient = useQueryClient()
  const cachedChatParticipantsKey = getCachedChatParticipantsKey({
    variables: { chatId },
  })

  return useQuery<Record<string, ChatParticipant>>(
    cachedChatParticipantsKey,
    () => {
      return queryClient.getQueryData(cachedChatParticipantsKey)
    },
    {
      initialData: {},
    },
  )
}
